import { Component, h } from '@stencil/core';
import {SessionService} from '../../services/session.service';
import { i18n } from '../../utils/I18n';

@Component({
  tag: 'nj-support-id',
  styleUrl: 'nj-support-id.scss',
  shadow: true,
})
export class NjSupportId {

  render() {
    return (
      <div class="supportContainer">
        <nj-infobox waAriaLabel={i18n.getMessage('support.info.label')}>
          <span slot="infobox-handle" class="linkText">{i18n.getMessage("support-id.link-text")}</span>
          <div>
            <p>{i18n.getMessage("support.line1")}</p>
            <p>{i18n.getMessage("support-id.support-id")} {SessionService.instance.getPublicId()}</p>
          </div>
        </nj-infobox>
      </div>
    );
  }
}
